import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    page: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXXL,
        padding: tokens.spacingHorizontalSNudge,
        height: '100%',
        minHeight: 0,
    },
    container: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: '1fr',
        ...shorthands.gap(tokens.spacingVerticalL),
        flex: 1,
        minHeight: 0,
        height: '100%',
        width: '100%',
    },
    leftColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXXL,
        minHeight: 0,
        height: '100%',
    },
    rightColumn: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        height: '100%',
        position: 'relative',
    },
    documentDialog: {
        width: '95vw',
        height: '95vh',
        maxWidth: '95vw',
        maxHeight: '95vh',
        padding: 0,
    },
    dialogCloseButton: {
        position: 'absolute',
        top: tokens.spacingVerticalM,
        right: tokens.spacingHorizontalM,
        zIndex: 1000,
    },
    dialogBackdrop: {
        backgroundColor: 'transparent',
    },
});
